import de from './de.json';
import fr from './fr.json';
import it from './it.json';

export const DEFAULT_LANGUAGE = 'de';
export const LANGUAGES = ['de', 'fr', 'it'] as const;
export type Language = (typeof LANGUAGES)[number];

const ACCEPTABLE_LANGUAGES_SET = new Set<string>(LANGUAGES);
export function isValidLanguage(language: string): language is Language {
    return ACCEPTABLE_LANGUAGES_SET.has(language);
}

export function getTranslations(language: Language): Record<string, string> {
    switch (language) {
        case "de": return de;
        case "fr": return fr;
        case "it": return it;
    }
}